module.exports = __webpack_public_path__ + "static/assets/c009ae2871804e1b34139b30acf1dce9.jpg";